import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';
import PublicUploadTree from './PublicUploadTree';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const location = useLocation();

  const handleParticipate = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      setShowUpload(true);
    }, 500);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-primary">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-8">
            <Logo size="md" />
            <div className="hidden md:flex items-center space-x-6 text-sm">
              <Link to="/" className="text-white hover:text-secondary transition-colors">
                Inicio
              </Link>
              <Link to="/reglas" className="text-white hover:text-secondary transition-colors">
                Reglas
              </Link>
              <Link to="/premios" className="text-white hover:text-secondary transition-colors">
                Premios
              </Link>
              <Link to="/patrocinadores" className="text-white hover:text-secondary transition-colors">
                Patrocinadores
              </Link>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <button 
              onClick={handleParticipate}
              className="bg-secondary text-white px-6 py-2 rounded-full text-sm transition-all transform hover:scale-105 hover:shadow-[0_0_15px_rgba(255,78,80,0.4)] shadow-[0_0_10px_rgba(255,78,80,0.2)] border-2 border-white/20 hover:bg-secondary/90"
            >
              ¡Inscribirse!
            </button>

            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 text-white hover:text-secondary transition-colors"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden border-t border-white/10">
            <div className="py-4 space-y-4">
              <Link 
                to="/"
                onClick={() => setIsMenuOpen(false)}
                className="block text-white hover:text-secondary transition-colors py-2"
              >
                Inicio
              </Link>
              <Link 
                to="/reglas"
                onClick={() => setIsMenuOpen(false)}
                className="block text-white hover:text-secondary transition-colors py-2"
              >
                Reglas
              </Link>
              <Link 
                to="/premios"
                onClick={() => setIsMenuOpen(false)}
                className="block text-white hover:text-secondary transition-colors py-2"
              >
                Premios
              </Link>
              <Link 
                to="/patrocinadores"
                onClick={() => setIsMenuOpen(false)}
                className="block text-white hover:text-secondary transition-colors py-2"
              >
                Patrocinadores
              </Link>
            </div>
          </div>
        )}
      </div>

      {showUpload && <PublicUploadTree onClose={() => setShowUpload(false)} />}
    </nav>
  );
}